"use client";

import { useEffect } from "react";
import { useEnvVariablesClientConfig } from "@contexts/env-variables-context";
import { initDatadogRum } from "@utils/client/datadog-rum";

export default function DatadogRumInit() {
  const envs = useEnvVariablesClientConfig();

  useEffect(() => {
    const applicationId = envs?.DD_RUM_APPLICATION_ID;
    const clientToken = envs?.DD_RUM_CLIENT_TOKEN;

    if (!applicationId || !clientToken) return;

    initDatadogRum({
      applicationId,
      clientToken,
      site: "datadoghq.com",
      service: "acko-labs-frontend",
      env: envs?.DD_RUM_ENV || envs?.ACKO_ENV || undefined,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
    });
  }, [
    envs?.ACKO_ENV,
    envs?.DD_RUM_APPLICATION_ID,
    envs?.DD_RUM_CLIENT_TOKEN,
    envs?.DD_RUM_ENV,
  ]);

  return null;
}

